import i18n from '@/common/i18n';
import { range } from 'lodash-es';
import computedLocale from '@/common/utils/computedLocale';

export enum PRESETS_NAME {
  CUSTOM = 'custom',
  ROTATION_7 = 'rotation-7',
  ROTATION_14 = 'rotation-14',
}

export const ALL_VALUES = '*';

export const PRESET_ALL_VALUES: Record<string, string> = {
  month: range(1, 13).join(','),
  day_of_week: range(0, 7).join(','),
  day: range(1, 32).join(','),
  startTime: range(0, 24).map((hour: number) => `${String(hour).padStart(2, '0')}:00`).join(','),
};

export const PRESET_VALUES = {
  [PRESETS_NAME.ROTATION_7]: {
    month: ALL_VALUES,
    day_of_week: ALL_VALUES,
    day: ALL_VALUES,
    hour: '2',
    recovery_points_rotation: 7
  },
  [PRESETS_NAME.ROTATION_14]: {
    month: ALL_VALUES,
    day_of_week: ALL_VALUES,
    day: ALL_VALUES,
    hour: '2',
    recovery_points_rotation: 14
  },
  [PRESETS_NAME.CUSTOM]: {
    month: '',
    day_of_week: '',
    day: '',
    hour: '',
    recovery_points_rotation: 7
  },
};

export const PRESET_OPTIONS = computedLocale<Record<PRESETS_NAME, { label: string, subLabel: string }>>(() => ({
  [PRESETS_NAME.ROTATION_7]: {
    label: i18n.t('Retention 7 days'),
    subLabel: i18n.t('A backup is created every day starting from 02:00 AM and kept for 7 days.'),
  },
  [PRESETS_NAME.ROTATION_14]: {
    label: i18n.t('Retention 14 days'),
    subLabel: i18n.t('A backup is created every day starting from 02:00 AM and kept for 14 days.'),
  },
  [PRESETS_NAME.CUSTOM]: {
    label: i18n.t('Custom'),
    subLabel: i18n.t('Configure schedule for the automatic backup.'),
  }
}));
